import { useEffect } from 'react';

import { EditRoleContextProvider } from 'lib/context/Role/EditRoleContext/EditRoleContextProvider';
import { NewRoleContextProvider } from 'lib/context/Role/NewRoleContext/NewRoleContextProvider';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import InfoBanner from 'components/shared/OnboardingWizard/components/InfoBanner/InfoBanner';

import Allowed from '../shared/Permissions/Allowed';

import Table from './OnboardingRolesTable';

const OnboardingRoles = ({
  isAdmin = false,
  forAdmin = false,
  setHeaderButtonProps,
  setHeaderInfoTooltip,
  addFooterActions,
  onNext,
  mutateOrchestratorData,
  orchestratorLoading
}) => {
  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: async () => {
          await mutateOrchestratorData({});
          onNext();
        },
        isDisabled: orchestratorLoading
      }
    ]);
  }, [orchestratorLoading]);

  return (
    <div className="flex flex-1 flex-col gap-4">
      <InfoBanner
        title="How roles work"
        description="Roles control what each team member can view, edit, and perform in Myriad. Create roles such as Front Desk, Biller, or Provider, and customize their permissions to match your workflows. You can create as many roles as needed—from administrative to clinical. Once your roles are set, you'll assign staff members to them in the next step. Permissions can be updated anytime as your practice evolves."
        onDismiss={setHeaderInfoTooltip}
      />
      <div className="min-h-0 flex-1">
        <Allowed
          requiredPermissions={forAdmin ? 'admin_role.create' : 'role.create'}
          showIllustration
          showMessage>
          <NewRoleContextProvider forAdmin={forAdmin}>
            <EditRoleContextProvider forAdmin={forAdmin}>
              <Table
                isAdmin={isAdmin}
                forAdmin={forAdmin}
                setHeaderButtonProps={setHeaderButtonProps}
              />
            </EditRoleContextProvider>
          </NewRoleContextProvider>
        </Allowed>
      </div>
    </div>
  );
};

export default withErrorBoundary(OnboardingRoles);
